<template>
  <div class="animated fadeIn">
    <b-modal
      ref="modal-template-preview"
      scrollable
      centered
      button-size="md"
      v-on:close="hideModal"
    >
      <template #modal-title><i class="fas fa-file-alt"></i> INFORMAÇÕES</template>
      <div class="pb-4">
        <ul>
          <li class="pt-3">Campanha: <strong>{{card.utmCampaign ? card.utmCampaign : '-'}}</strong></li>
          <small>utmCampaign</small>
          <li class="pt-3">Conjunto: <strong>{{card.utmContent ? card.utmContent : '-'}}</strong></li>
          <small>utmContent</small>
          <li class="pt-3">Meio: <strong>{{card.utmMedium ? card.utmMedium : '-'}}</strong></li>
          <small>utmMedium</small>
          <li class="pt-3">Plataforma: <strong>{{card.utmSource ? card.utmSource : '-'}}</strong></li>
          <small>utmSource</small>
          <li class="pt-3">Criativo: <strong>{{card.utmTerm ? card.utmTerm : '-'}}</strong></li>
          <small>utmTerm</small>
        </ul>
      </div>
      <!-- <div class="pb-4">
        <label for="txtDescription"> Preview:</label>
        <div
          style="border: solid 1px #ccc; border-radius: 3px; min-width: 100%;min-height: 543px; max-height: 543px; padding: 7px; overflow: scroll;"
        >
          <div v-html="template"></div>
        </div>
      </div> -->
      <template #modal-footer>
        <div class="w-100 text-right">
          <button
            @click="hideModal"
            type="button"
            class="btn btn-third btn-sm"
            v-b-tooltip.hover
            :title="'Fechar'"
          >
            <i :class="'fas fa-times'"></i
            ><span class="d-md-down-none">&nbsp; Fechar</span>
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'

export default {
  name: 'UtmTemplateModal',
  mixins: [ActionsForm],
  data () {
    return {
      card: ''
    }
  },
  methods: {
    onLoad () {},
    showModal (card) {
      this.$refs['modal-template-preview'].show()
      this.card = card
    },
    hideModal () {
      this.$refs['modal-template-preview'].hide()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/crm/details/campanha/modal/UtmTemplateModal.vue